import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SelectedSubstationForSchematic } from '../nec-modals/nec-add-new-instance-equipment/nec-add-new-instance-equipment.component';
import { ToastrService } from 'ngx-toastr';
import { SubstationTemplateService } from '../../../services/substation-template.service';
import { SubstationTemplateForSelect } from '../../../models/network-structure.model';
import { UtilitySharedService } from '../../../services/shared//utility-shared.service';
import { CimSubstationService } from '../../../services/cim-substation.service';
import { GeographicalRegion } from '../../../models/geographical-region.model';
import { GeographicalRegionService } from '../../../services/geographical-region.service';
import { SubGeographicalRegion } from '../../../models/sub-geographical-regions.model';
import { SubGeographicalRegionService } from '../../../services/sub-geographical-region.service';
import { BaseVoltageService } from '../../../services/base-voltage.service';
import { MeterBrand } from '../../../models/meter-brand.model';
import { MeterBrandService } from '../../../services/meter-brand.service';
import { CimSubstationFilter, CimSubstationForSave, ParentSubstation, SearchType, SubstationHistoryDataOut } from '../../../models/cim-substation.model';
import { ObjectDropdownComponent } from '../../common/object-dropdown/object-dropdown.component';
import { SelectSubstationDataIn } from '../../../models/substation-template-instance.model';
import { Router } from '@angular/router';
import { UploadFileType } from '../../../models/uploadFileInfo.model';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
  selector: 'lib-nec-substation',
  standalone: false,
  templateUrl: './nec-substation.component.html',
  styleUrls: ['./nec-substation.component.scss', '../network-entity-classes.component.scss'],
})
export class NecSubstationComponent implements OnInit{
  @ViewChild('closeEditModal') closeEditModal!: ElementRef;
  @ViewChild('dropdownVoltage') dropdownVoltage!: ObjectDropdownComponent;
  @ViewChild('dropdownInstance') dropdownInstance!: ObjectDropdownComponent;
  @ViewChild('dropdownRegion') dropdownRegion!: ObjectDropdownComponent;
  @ViewChild('dropdownDistrict') dropdownDistrict!: ObjectDropdownComponent;
  @ViewChild('dropdownMeterBrand') dropdownMeterBrand!: ObjectDropdownComponent;
  @ViewChild('dropdownParentSubstation') dropdownParentSubstation!: ObjectDropdownComponent;
  @ViewChild('dropdownAcLineOutgoing') dropdownAcLineOutgoing!: ObjectDropdownComponent;
  
  utilityId!: number;
  isEdit: boolean = false;
  selectedSubstation: any = null;
  actionMenuOpenForId: number | null = null;
  selectedId: number = 0;
  selectedName: string = '';
  uploadModalOpened: boolean = false; 
  updateModalOpened: boolean = false; 
  UploadFileType: UploadFileType = UploadFileType.Substations;

  filterOpened: boolean = false;
  searchDropdownOpened: boolean = false;
  filter = new CimSubstationFilter();
  SearchType = SearchType;

  currentPage: number = 1;
  pageSize: number = 10;
  pageSizes = [10, 20];
  count: number = 0;

  selectedTabId: number = 1;
  selectedTabName: string = '';

  tabs: any[] = [];

  substationTemplatesForSelect: SubstationTemplateForSelect[] = []
  substationTemplateValue: SubstationTemplateForSelect | null = null;

  substationTemplateInstances: any[] = []

  geoRegions: GeographicalRegion[] = [];
  geographicalRegionValue: GeographicalRegion | null = null;
  updatedRegionId: number | null = null;

  subGeoRegions: SubGeographicalRegion[] = [];
  subGeographicalRegionValue: SubGeographicalRegion | null = null;
  allSubGeoRegions: SubGeographicalRegion[] = [];

  baseVoltages: any[] = [];
  baseVoltageValue: any | null = null;
  meterBrands: MeterBrand[] = [];
  meterBrandValue: MeterBrand | null = null;

  substationForSave: CimSubstationForSave = new CimSubstationForSave();

  parentSubstations: any[] = []; //for select
  updatedParentSubstationId: number | null = null; //using SubstationId, not SubstationTemplateInstanceId

  isDetailsOpen: boolean = false;
  substationDetails: any;
  substationHistoryItems: SubstationHistoryDataOut[] = [];

  @Input() pendingSubstationToOpen: SelectedSubstationForSchematic | null = null;
  @Output() pendingSubstationHandled = new EventEmitter<void>();
  autoOpenSchematicOnDetails: boolean = false;

  outgoingAcLineSegments: any[] = []
  updatedAcLineOutgoingId: number | null = null;
  updateAcLineOutgoingName: string | null = null;

  suppliedRegionName: string = '';
  suppliedDistrictName: string = '';

  showParentSubstationDropdowns: boolean = true;
  addedAcLinesOutgoing: any[] = []

  constructor
  (
    private toastr: ToastrService, 
    private substationTemplateService: SubstationTemplateService,
    private utilitySharedService: UtilitySharedService,
    private cimSubstationService: CimSubstationService,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService,
    private baseVoltageService: BaseVoltageService,
    private meterBrandService: MeterBrandService,
    private router: Router,
    public permissionsService: PermissionsService
  ){}

  ngOnInit(): void {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
    this.filter.searchType = SearchType.Name;
    this.getAllSubstationTemplatesForSelect();
    this.getAllGeographicalRegionsForSelect();
    this.getAllBaseVoltagesForSelect();
    this.getAllMeterBrandsForSelect();
    this.getAllParentSubstationsForSelect(new SelectSubstationDataIn(""));

    if (this.pendingSubstationToOpen) {
      this.getSubstationTemplateTabs();
      this.openPendingSubstation(this.pendingSubstationToOpen);
    } else {
      this.getSubstationTemplateTabs(0);
    }
  }

  openPendingSubstation(pending: SelectedSubstationForSchematic) {
    this.switchTab({
      substationTemplateId: pending.substationTemplateId,
      substationTemplateName: pending.substationTemplateName,
    });
    this.autoOpenSchematicOnDetails = true;
    this.openDetails({
      id: pending.id,
      substationId: pending.substationId,
      name: pending.name,
    });
    this.pendingSubstationHandled.emit();
  }

  onAutoOpenSchematicHandled() {
    // Deferred: NecSubstationDetailsComponent emits this synchronously from its own ngOnInit,
    // which runs mid change-detection pass. Clearing autoOpenSchematicOnDetails immediately
    // would mutate a value Angular already checked in this same pass (NG0100).
    setTimeout(() => (this.autoOpenSchematicOnDetails = false));
  }

  getSubstationTemplateTabs(id?: number){
    this.cimSubstationService.getStats().subscribe({
      next: (response: any) => {
        this.tabs = response?.body?.data ?? [];
        if (id != null) {
          this.switchTab(this.tabs.find(t => t.substationTemplateId === id) ?? this.tabs[0]);
        }
      }
    })
  }

  toggleActionMenu(substationTemplateInstance: any, event: MouseEvent) {
    event.stopPropagation();
    this.selectedId = substationTemplateInstance.id!;
    this.selectedName = substationTemplateInstance.name;
    this.actionMenuOpenForId =
      this.actionMenuOpenForId === substationTemplateInstance.id ? null : substationTemplateInstance.id;
  }

  selectSubstation(substation: any){
    this.isEdit = true;
    this.selectedSubstation = substation;

    this.substationForSave = new CimSubstationForSave();
    this.substationForSave.id = substation.id;
    this.substationForSave.substationTemplateId = this.selectedTabId;
    this.substationForSave.name = substation.name;
    this.substationForSave.number = substation.number;
    this.substationForSave.baseVoltageId = substation.baseVoltage?.id;
    this.substationForSave.subGeographicalRegionId = substation.subGeographicalRegion?.id;
    this.substationForSave.meterNumber = substation.meterNumber ?? '';
    this.substationForSave.meterBrandId = substation.meterBrandId ?? null;
    this.substationForSave.latitude = substation.latitude ?? null;
    this.substationForSave.longitude = substation.longitude ?? null;
    this.meterBrandValue = this.meterBrands.find(b => b.id === substation.meterBrandId) ?? null;

    if(substation.baseVoltage)
      substation.baseVoltage.name = substation.baseVoltage?.nominalVoltage + 'KV';
    this.baseVoltageValue = substation.baseVoltage;
    this.geographicalRegionValue = substation.subGeographicalRegion?.geographicalRegion;

    if(this.geographicalRegionValue)
      this.geographicalRegionValue!.name = this.geographicalRegionValue?.name.toUpperCase() ?? '';
    this.onSelectGeographicalRegion(substation.subGeographicalRegion?.geographicalRegion, false);
    this.subGeographicalRegionValue = substation.subGeographicalRegion;
    this.substationTemplateValue = new SubstationTemplateForSelect(this.selectedTabId, this.selectedTabName);

    this.showParentSubstationDropdowns = true;
    this.substationForSave.parentSubstations = []
    this.addedAcLinesOutgoing = []
    if(substation.parentSubstations?.length !== 0)
      this.setParentSubstationData(substation.parentSubstations);

    this.suppliedRegionName = substation.subGeographicalRegion?.geographicalRegion.name;
    this.suppliedDistrictName = substation.subGeographicalRegion?.name;
  }

  setParentSubstationData(parentSubstationsInit: any){

    if (!this.substationForSave.parentSubstations) {
      this.substationForSave.parentSubstations = [];
    }

    if (parentSubstationsInit && Array.isArray(parentSubstationsInit)) {
      parentSubstationsInit.forEach((ps: any) => {
        const mappedItem: ParentSubstation = {
          parentSubstationId: ps.parentSubstationId,       
          parentSubstationACLineId: ps.parentACLineId 
        };

        this.substationForSave.parentSubstations!.push(mappedItem);
      });
    }

    if (parentSubstationsInit && Array.isArray(parentSubstationsInit)) {
      parentSubstationsInit.forEach((ps: any) => {
        const mappedItem: any = {
          acLineId: ps.parentACLineId,
          acLineName: ps.parentACLineName,
          isExisting: true // existing incoming lines can only be removed on the schematic
        };

        this.addedAcLinesOutgoing.push(mappedItem);
      });
    }

    this.showParentSubstationDropdowns = false;
  }

  save(){
    if (this.substationForSave.substationTemplateId === null) {
      this.toastr.warning("Please select an instance category!")
    } else if(this.substationForSave.name === ''){
      this.toastr.warning("Asset Name can't be empty!")
    } else if (this.substationForSave.number === '') {
      this.toastr.warning("Asset Number can't be empty!")
    } else if (this.substationForSave.baseVoltageId === null) {
      this.toastr.warning("Please select a base voltage category!")
    } else if (this.substationForSave.subGeographicalRegionId === null) {
      this.toastr.warning("Please select a district category!")
    } else if ((this.substationForSave.latitude == null) !== (this.substationForSave.longitude == null)) {
      this.toastr.warning("Latitude and Longitude must both be provided or both left empty!")
    } else if (this.substationForSave.latitude != null && (this.substationForSave.latitude < -90 || this.substationForSave.latitude > 90)) {
      this.toastr.warning("Latitude must be between -90 and 90!")
    } else if (this.substationForSave.longitude != null && (this.substationForSave.longitude < -180 || this.substationForSave.longitude > 180)) {
      this.toastr.warning("Longitude must be between -180 and 180!")
    } else {
       this.cimSubstationService.save(this.substationForSave).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(this.isEdit ? 'Substation updated successfully' : 'Substation created successfully');
          this.getSubstationTemplateTabs(this.substationForSave.substationTemplateId!);
          this.getSubstationTemplateInstances();
          this.closeEditModal?.nativeElement?.click();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
    }
  }

  onRemove(){
    this.cimSubstationService.delete(this.selectedId, this.selectedTabId, this.selectedName).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(responseData?.message);
          this.getSubstationTemplateInstances();
          this.getSubstationTemplateTabs(this.selectedTabId);
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
    this.actionMenuOpenForId = null;
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getSubstationTemplateInstances();
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.currentPage = 1;
    this.getSubstationTemplateInstances();
  }

  openAddModal(){
    this.isEdit = false;
    this.selectedSubstation = null;
    this.showParentSubstationDropdowns = true;

    this.dropdownVoltage.selectItem(null);
    this.dropdownRegion.selectItem(null);
    this.dropdownInstance.selectItem(null);
    this.dropdownDistrict.selectItem(null);
    this.dropdownMeterBrand.selectItem(null);
    this.dropdownParentSubstation?.selectItem(null);
    this.dropdownAcLineOutgoing?.selectItem(null);

    this.substationForSave = new CimSubstationForSave();
    this.meterBrandValue = null;

    this.updatedRegionId = null;
    this.updatedParentSubstationId = null;
    this.updatedAcLineOutgoingId = null;

    this.addedAcLinesOutgoing = [];

    this.suppliedRegionName = '';
    this.suppliedDistrictName = '';
  }

  switchTab(tab: any){
    if(tab){
      this.selectedTabId = tab.substationTemplateId;
      this.selectedTabName = tab.substationTemplateName;
      this.currentPage = 1;
      this.filter.substationTemplateId = tab.substationTemplateId;
      this.getSubstationTemplateInstances();
    }
  }

  getSubstationTemplateInstances(isSaveFromDetails: boolean = false){
     let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.filter
    };
    this.cimSubstationService.getAll(dataIn).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.substationTemplateInstances = responseData.data.data;
          this.count = responseData.data.count;
          if(isSaveFromDetails){
            var substationTemplateInstance = this.substationTemplateInstances.find(t => t.id === this.substationDetails.id);
            // Not on this page when the details were opened from elsewhere (e.g. "Add" on another list); keep them as they are.
            // TO DO: remove this after implementing cim substation getById for details
            if (substationTemplateInstance)
              this.openDetails(substationTemplateInstance);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  @HostListener('document:click')
  closeActionMenu() {
    if (this.actionMenuOpenForId !== null) {
      this.actionMenuOpenForId = null;
    }
  }

  getAllSubstationTemplatesForSelect() {
    this.substationTemplateService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.substationTemplatesForSelect = responseData.data.map((substationTemplate: SubstationTemplateForSelect) => ({
            ...substationTemplate
          }));
        } else if (response?.status === 204) {
          this.substationTemplatesForSelect = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading substation templates');
      },
    });
  }

  onSelectSubstationTemplate(obj: SubstationTemplateForSelect | null) {
    if (obj)
      this.substationForSave.substationTemplateId = obj.id ?? 0;
  }

  getAllGeographicalRegionsForSelect() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geoRegions = responseData.data.map((geoRegion: GeographicalRegion) => ({
            ...geoRegion,
            name: geoRegion.name?.toUpperCase(),
            isExpanded: false,
          }));
          this.loadAllSubGeographicalRegions();
        } else if (response?.status === 204) {
          this.geoRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading regions');
      },
    });
  }

  loadAllSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allSubGeoRegions = responseData.data.map((subGeoRegion: SubGeographicalRegion) => ({
            ...subGeoRegion,
            isExpanded: false,
          }));
        } else if (response?.status === 204) {
          this.allSubGeoRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading districts');
      },
    });
  }

  onSelectGeographicalRegion(obj: GeographicalRegion | null, isNotEditInit: boolean = true) {
    if (obj){
      this.updatedRegionId = obj.id;
      this.suppliedRegionName = obj.name;
      this.suppliedDistrictName = '';
       if(isNotEditInit){
        this.dropdownDistrict.selectItem(null);
        this.substationForSave.subGeographicalRegionId = null;
      }
      this.getAllSubGeographicalRegionsForSelect(obj.id ?? 0);
    }
  }

  getAllSubGeographicalRegionsForSelect(regionId: number){
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.subGeoRegions = responseData.data
          .filter((subGeoRegions: SubGeographicalRegion) => subGeoRegions.geographicalRegion.id === regionId)  
          .map((subGeoRegions: SubGeographicalRegion) => ({
            ...subGeoRegions,
            isExpanded: false,
          }));
        } else if (response?.status === 204) {
          this.subGeoRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading districts');
      },
    });
  }

  onSelectSubGeographicalRegion(obj: SubGeographicalRegion | null) {
    if (obj){
      this.suppliedDistrictName = obj.name;
      this.substationForSave.subGeographicalRegionId = obj.id!;
    }   
  }

  getAllBaseVoltagesForSelect() {
    this.baseVoltageService.getAllForMappings(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.baseVoltages = responseData.data;
        } else if (response?.status === 204) {
          this.baseVoltages = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading base voltages');
      },
    });
  }

  onSelectBaseVoltage(obj: any | null) {
    if (obj)
      this.substationForSave.baseVoltageId = obj.id ?? 0;
  }

  getAllMeterBrandsForSelect() {
    this.meterBrandService.getAllForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.meterBrands = responseData.data;
        } else if (response?.status === 204) {
          this.meterBrands = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading meter brands');
      },
    });
  }

  onSelectMeterBrand(obj: MeterBrand | null) {
    this.substationForSave.meterBrandId = obj?.id ?? null;
  }

  getAllParentSubstationsForSelect(dataIn: SelectSubstationDataIn){
    this.cimSubstationService.getForSelect(dataIn).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.parentSubstations = responseData.data.map((parentSubstation: any) => ({
            ...parentSubstation
          }));
        } else if (response?.status === 204) {
          this.parentSubstations = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading parent substations');
      },
    });
  }

  onSelectParentSubstation(obj: any | null){
    if (obj){
      this.updatedParentSubstationId = obj.id;
      this.getAllOutgoingLines(obj.id ?? 0);
    }
  }

  getAllOutgoingLines(substationId: number){
      this.cimSubstationService.getOutgoingLines(substationId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.outgoingAcLineSegments = responseData.data.map((outgoingAcLineSegment: any) => ({
            ...outgoingAcLineSegment
          }));
        } else if (response?.status === 204) {
          this.outgoingAcLineSegments = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading outgoing ac line segments');
      },
    });
  }

  onSelectAcLineOutoging(obj: any | null){
    if (obj){
      this.updatedAcLineOutgoingId = obj.id;
      this.updateAcLineOutgoingName = obj.name;
      this.addParentSubstationAndAcLineOutoging();
    }
  }

  addParentSubstationAndAcLineOutoging(){
    if(this.substationForSave.parentSubstations?.some(p => p.parentSubstationACLineId === this.updatedAcLineOutgoingId)){
      this.toastr.warning("You already added this Ac Line.")
      this.showParentSubstationDropdowns = false;
      return;
    };

    this.createAcLineLabelForModal();

    const newItem: ParentSubstation = {
      parentSubstationId: this.updatedParentSubstationId,
      parentSubstationACLineId: this.updatedAcLineOutgoingId
    };

    if (!this.substationForSave.parentSubstations) {
      this.substationForSave.parentSubstations = [newItem]; 
    } else {
      this.substationForSave.parentSubstations.push(newItem); 
    }

    this.showParentSubstationDropdowns = false;

    this.updatedParentSubstationId = null;
    this.updatedAcLineOutgoingId = null;
  }

  createAcLineLabelForModal(){
    const newItem: any = {
      acLineId: this.updatedAcLineOutgoingId,
      acLineName: this.updateAcLineOutgoingName
    };

    if (!this.addedAcLinesOutgoing) {
      this.addedAcLinesOutgoing = [newItem]; 
    } else {
      this.addedAcLinesOutgoing.push(newItem); 
    }
  }

  removeFromLists(acLineId: number){
    if(!this.substationForSave.parentSubstations) return;

    this.addedAcLinesOutgoing = this.addedAcLinesOutgoing.filter(p => p.acLineId !== acLineId);
    this.substationForSave.parentSubstations = this.substationForSave.parentSubstations!.filter(p => p.parentSubstationACLineId !== acLineId);

    if(!this.substationForSave.parentSubstations || this.substationForSave.parentSubstations.length === 0)
      this.showParentSubstationDropdowns = true;
  }

  onSearchTextChange(inputText: string){
      this.getAllParentSubstationsForSelect(new SelectSubstationDataIn(inputText));
  }

  addParentSubstation() {
    this.showParentSubstationDropdowns = true;
  }

  viewHistory(substationId: number) {
    this.cimSubstationService.getHistory(substationId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.substationHistoryItems = responseData.data ?? [];
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch history');
        }
      },
      error: (_: any) => {
        this.toastr.error('Failed to fetch history');
      },
    });
  }

  openDetails(substationTemplate: any){
    this.substationDetails = {
      ...substationTemplate,
      substationTemplateId: this.selectedTabId,
      substationTemplateName: this.selectedTabName
    };
    this.isDetailsOpen = true;
  }

  closeDetailsAndRefresh(isSave: boolean){
    this.getSubstationTemplateInstances(isSave);
    if(!isSave){
      this.getSubstationTemplateTabs();
      this.isDetailsOpen = false;
    }
  }

  selectSearchType(searchType: SearchType){
    this.filter.searchType = searchType;
    this.filter.searchValue = '';
    this.searchDropdownOpened = false;
  }

  onFilterApplied() {
    this.filterOpened = false;
    this.currentPage = 1;
    this.getSubstationTemplateInstances();
  }

  openUploadModal(feederReassignment: boolean = false) {
    this.UploadFileType = feederReassignment
      ? UploadFileType.BulkFeederReassignment
      : UploadFileType.Substations;

    this.uploadModalOpened = true;
  }

  openUpdateModal() {
    this.UploadFileType = UploadFileType.BulkSubstationUpdate;

    this.uploadModalOpened = true;
  }

  download() {
    const dataIn = {
      pageInfo: {
        page: -1,
        pageSize: -1,
      },
      filterParams: this.filter,
    };
    this.cimSubstationService.downloadUntaggedSubstations(dataIn).subscribe({
      next: (response: any) => {
        if (response?.status === 'OK' || response?.status === 200) {
          window.location.href = response.data;
        } else {
          this.toastr.error(response?.message || 'Download failed.');
        }
      },
      error: (_: any) => {
        this.toastr.error('An error occurred during download.');
      },
    });
  }
}
